/**
 * "View as role" / simulation state
 * Lets admins temporarily see the app with another role's permissions (for testing).
 */

const SIMULATE_KEY = 'cfc_simulate';

/**
 * Get current simulation state, if any.
 * @returns {{ roleId: number, roleName: string, permissions: string[] } | null}
 */
export function getSimulate() {
  try {
    const raw = localStorage.getItem(SIMULATE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

/**
 * Store simulation state (viewing as a role).
 * @param {{ roleId: number, roleName: string, permissions: string[] }} data
 */
const SIMULATE_CHANGED = 'cfc-simulate-changed';

export function setSimulate(data) {
  if (data) {
    localStorage.setItem(SIMULATE_KEY, JSON.stringify(data));
  } else {
    localStorage.removeItem(SIMULATE_KEY);
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(SIMULATE_CHANGED));
  }
}

/**
 * Clear simulation and use real user permissions again.
 */
export function clearSimulate() {
  localStorage.removeItem(SIMULATE_KEY);
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(SIMULATE_CHANGED));
  }
}

/** Event name for "View as" changed (so pages can refetch whoami). */
export const SIMULATE_CHANGED_EVENT = SIMULATE_CHANGED;
